var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      {
        key: _vm.item.id,
        class: ["calendar-item", ..._vm.item.classes],
        style: [{ top: _vm.top }, _vm.item.style ?? ""],
        on: {
          dragstart: function ($event) {
            return _setup.emit("dragstart", $event)
          },
          mouseenter: function ($event) {
            return _setup.emit("mouseenter", $event)
          },
          mouseleave: function ($event) {
            return _setup.emit("mouseleave", $event)
          },
          click: function ($event) {
            return _setup.emit("click", $event)
          },
        },
      },
      "div",
      _setup.elemAttrs,
      false
    ),
    [
      _setup.calendar.showTimes
        ? [
            _c("span", { staticClass: "start-time" }, [
              _vm._v(_vm._s(_setup.displayTimeRange.start)),
            ]),
            _vm._v(" "),
            _setup.displayTimeRange.end
              ? _c("span", { staticClass: "end-time" }, [
                  _vm._v(_vm._s(_setup.displayTimeRange.end)),
                ])
              : _vm._e(),
          ]
        : _c("span", [_vm._v(_vm._s(_vm.item.title ?? ""))]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }